import { render, staticRenderFns } from "./PriceFunFood.vue?vue&type=template&id=74545f80&scoped=true"
import script from "./PriceFunFood.vue?vue&type=script&lang=js"
export * from "./PriceFunFood.vue?vue&type=script&lang=js"
import style0 from "./PriceFunFood.vue?vue&type=style&index=0&id=74545f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74545f80",
  null
  
)

export default component.exports